var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"test_com"},[_c('upfile',{attrs:{"name":"上传图片","many":1,"action":"https://weixin.qiyehuo.com/api/ysy_aly_common_upload","mul":false,"up_path":{'des':_vm.des},"bus":"abcde","acc":".jpeg,.jpg,.png,.pdf","acce":['img','pdf']}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3836b2e5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ysy/testCom.vue
// module id = null
// module chunks = 